var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-2 mr-2 px-2",attrs:{"color":"primary","dark":""},on:{"click":_vm.handle}},[_vm._v(" Pobierz "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-cloud-download ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }